import userService from "../services/userService.js";

export const user = {
  namespaced: true,
  state: {
    current: {}
  },
  actions: {
    login({commit}) {
      commit('clear');
      if (userService.isLogged()) {
        return userService.getCurrentUser()
          .then(
            user => commit('getUserSuccess', user),
            error => commit('getUserFailure', error)
          );
      }
      return Promise.resolve();
    },
    logout({commit}) {
      commit('clear');
    }
  },
  mutations: {
    getUserSuccess(state, user) {
      state.current = user;
    },
    getUserFailure(state, error) {
      // TODO show error ?
      state.current = null;
    },
    clear(state) {
      state.current = null;
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/user.module.js